export {
    ActivityGenerationForm,
    type ActivityGenerationFormProps,
    type ActivityGenerationStudyProgram,
} from "./ActivityGenerationForm"
